import { Route } from '@angular/router';
import { hasAuthTypeOrRedirectGuard } from '@rma/authentication/public/util-auth-redirect';
import { logRedirectNonLegacy, RmaEmptyComponent, stripProfileRedirectAngularGuard } from '@rma/generic/util/router-utils';

export const officeRoutes: Route[] = [
  {
    path: 'agency',
    children: [
      {
        path: '',
        canActivate: [hasAuthTypeOrRedirectGuard('office')],
        children: [
          // Remove after 2024-06-30 (check track js for logs) hasPlatformAccess guard may of been the cause updated on (May 20th, 2025)
          {
            path: 'linked-accounts',
            canActivate: [stripProfileRedirectAngularGuard('/settings')],
            canActivateChild: [stripProfileRedirectAngularGuard('/settings')],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
          // Remove after 2024-06-30 (check track js for logs) publish and manage was in public (resolved) (2025-06-06)
          {
            path: 'market-reports',
            canActivate: [stripProfileRedirectAngularGuard()],
            canActivateChild: [stripProfileRedirectAngularGuard()],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
          // Remove after 2024-06-30 (check track js for logs) DC Common Url Provider DataFeed (resolved) (2025-06-06)
          {
            path: 'data-feeds',
            canActivate: [logRedirectNonLegacy('/settings/data-feeds')],
            component: RmaEmptyComponent,
          },
        ],
      },
      //unauthenticated
      // Remove after 2024-06-30 ( check track js for logs)
      {
        path: '',
        children: [
          {
            path: 'data-feeds/:code',
            canActivate: [stripProfileRedirectAngularGuard('/settings')],
            canActivateChild: [stripProfileRedirectAngularGuard('/settings')],
            children: [
              {
                path: '**',
                component: RmaEmptyComponent,
              },
            ],
          },
        ],
      },
    ],
  },
];
